module.exports = __webpack_public_path__ + "static/media/package_dev_android_plain.bb4701eb.svg";